const countryCodeToPhoneNumberPlaceholder = {
  AU: '(00) 0000 0000',
  CA: '(000) 000-0000',
  GB: '00000 000000',
  JP: '000-0000-0000',
  US: '(000) 000-0000',
  default: '(000) 000-0000'
};
export function getPhoneNumberPlaceholder(countryCode) {
  return countryCodeToPhoneNumberPlaceholder[countryCode] ?? countryCodeToPhoneNumberPlaceholder.default;
}